import { render } from "./loader.vue?vue&type=template&id=72d1f0ba"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import exportComponent from "F:\\omar pos system\\pos_manager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__